export default __webpack_public_path__ + "static/media/trans_lung.2db4f225.png";